import React, { useState, useEffect } from 'react';
import { View, Text, Switch, StyleSheet } from 'react-native';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { speakText, isIOSDevice } from '../helpers/textToSpeech';

const TTSToggle = () => {
  const [isTTSEnabled, setIsTTSEnabled] = useState(false);
  const [shouldShowToggle, setShouldShowToggle] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const checkTTSSettings = async () => {
      try {
        if (!isIOSDevice()) {
          setShouldShowToggle(false);
          return;
        }

        const ttsEnabled = await AsyncStorage.getItem('ttsEnabled');
        
        if (ttsEnabled === 'false') {
          setShouldShowToggle(true);
          setIsTTSEnabled(false);
        } else {
          setShouldShowToggle(false);
        }
      } catch (error) {
        console.error('Error checking TTS settings:', error);
        setShouldShowToggle(false);
      }
    };

    checkTTSSettings();
  }, []);

  const handleTTSToggle = async (enabled) => {
    if (enabled) {
      setIsLoading(true);
      
      try {
        const result = await speakText('Voice enabled', { volume: 0.01 });
        
        if (result.success) {
          await AsyncStorage.setItem('ttsEnabled', 'true');
          setIsTTSEnabled(true);
          setShouldShowToggle(false);
        } else {
          console.warn('Failed to enable TTS:', result.error);
          setIsTTSEnabled(false);
        }
      } catch (error) {
        console.error('Error enabling TTS:', error);
        setIsTTSEnabled(false);
      } finally {
        setIsLoading(false);
      }
    } else {
      try {
        await AsyncStorage.setItem('ttsEnabled', 'false');
        setIsTTSEnabled(false);
      } catch (error) {
        console.error('Error disabling TTS:', error);
      }
    }
  };

  if (!shouldShowToggle) {
    return null;
  }

  return (
    <View style={styles.container}>
      <View style={styles.row}>
        <View style={styles.labelContainer}>
          <Text style={styles.label}>🔊 Enable Voice Guidance</Text>
          <Text style={styles.subtitle}>
            Get audio instructions for scanning items
          </Text>
        </View>
        <Switch
          testID="ttsToggle"
          value={isTTSEnabled}
          onValueChange={handleTTSToggle}
          disabled={isLoading}
          trackColor={{ false: '#767577', true: '#ffb636' }}
          thumbColor={isTTSEnabled ? '#d47d02' : '#f4f3f4'}
          ios_backgroundColor="#3e3e3e"
        />
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    paddingHorizontal: 20,
    paddingVertical: 10,
  },
  row: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  labelContainer: {
    flex: 1,
    marginRight: 15,
  },
  label: {
    color: 'white',
    fontSize: 16,
    fontWeight: '600',
    marginBottom: 4,
  },
  subtitle: {
    color: '#cccccc',
    fontSize: 14,
    lineHeight: 18,
  },
});

export default TTSToggle;